export interface userState {
  id: string;
  name: string;
  company: string;
  isAuth: boolean;
  isPermission: boolean;
  isAdmin: boolean;
  isSuperAdmin: boolean;
  apiUrl: string;
  picture: string;
}

export interface IMenuItem {
  name: string;
  iconType: string;
  icon: any;
  path: string;
  adminOnly?: boolean;
  children?: Array<IMenuItem>;
}

export interface CountryType {
  code: string;
  label: string;
  englabel: string;
  language?: string;
}

export const countries: readonly CountryType[] = [
  { code: "US", label: "영어", englabel: "United States", language: "English" },
  { code: "CN", label: "중국어", englabel: "China", language: "Chinese" },
  { code: "JP", label: "일본어", englabel: "Japan", language: "Japanese" },
  { code: "VN", label: "베트남어", englabel: "Vietnam", language: "Vietnamese" },
  { code: "TH", label: "태국어", englabel: "Thailand", language: "Thai" },
  { code: "KR", label: "한국어", englabel: "Korea", language: "Korean" },
];

export let adminApiUrl = "https://p5hiqy3lk2it2touv44gmwjxsi0eydcx.lambda-url.ap-northeast-2.on.aws/";

export const broadStatusName: any = {
  CREATE: "대기",
  READY: "대기",
  START: "방송",
  STOP: "종료",
  VOD: "VOD",
};

export const iotConfig: any = {
  region: "ap-northeast-2",
  identityPollId: "ap-northeast-2:77665984-fece-48ba-b102-140442a5220d",
  endpoint: "a1amragx8ri6g6-ats.iot.ap-northeast-2.amazonaws.com",
};

export const appConfig = {
  listChannelMode: "recent" /*recent or total*/,
  quote_separator: "⤷",
  vod_cloudfront_endpoint: "https://ezwel-vod.livehyundai.com",
  asset_cloudfront_endpoint: "https://ezwel-asset.livehyundai.com",
  chat_id_mask: false,
};

export const emojiList = [
  "😀",
  "😁",
  "😂",
  "😃",
  "😉",
  "😋",
  "😎",
  "😍",
  "😗",
  "🤗",
  "🤔",
  "😣",
  "😫",
  "😴",
  "😌",
  "🤓",
  "😛",
  "😜",
  "😠",
  "😇",
  "😷",
  "😈",
  "👻",
  "😺",
  "😸",
  "😹",
  "😻",
  "😼",
  "😽",
  "🙀",
  "🙈",
  "🙉",
  "🙊",
  "👼",
  "👮",
  "🕵",
  "💂",
  "👳",
  "🎅",
  "👸",
  "👰",
  "👲",
  "🙍",
  "🙇",
  "🚶",
  "🏃",
  "💃",
  "⛷",
  "🏂",
  "🏌",
  "🏄",
  "🚣",
  "🏊",
  "⛹",
  "🏋",
  "🚴",
  "👫",
  "💪",
  "👈",
  "👉",
  "👉",
  "👆",
  "🖕",
  "👇",
  "🖖",
  "🤘",
  "🖐",
  "👌",
  "👍",
  "👎",
  "✊",
  "👊",
  "👏",
  "🙌",
  "🙏",
  "🐵",
  "🐶",
  "🐇",
  "🐥",
  "🐸",
  "🐌",
  "🐛",
  "🐜",
  "🐝",
  "🍉",
  "🍄",
  "🍔",
  "🍤",
  "🍨",
  "🍪",
  "🎂",
  "🍰",
  "🍾",
  "🍷",
  "🍸",
  "🍺",
  "🌍",
  "🚑",
  "⏰",
  "🌙",
  "🌝",
  "🌞",
  "⭐",
  "🌟",
  "🌠",
  "🌨",
  "🌩",
  "⛄",
  "🔥",
  "🎄",
  "🎈",
  "🎉",
  "🎊",
  "🎁",
  "🎗",
  "🏀",
  "🏈",
  "🎲",
  "🔇",
  "🔈",
  "📣",
  "🔔",
  "🎵",
  "🎷",
  "💰",
  "🖊",
  "📅",
  "✅",
  "❎",
  "💯",
  "🩷",
  "❤️",
  "🧡",
  "💛",
  "💚",
  "🩵",
  "💙",
  "💜",
  "🖤",
  "🩶",
  "🤍",
  "🤎",
];
